module.exports = __webpack_public_path__ + "d-6IYplOFocCacKzxwXSOD8E0i7KZn-EPnyo3HZu7kw.525d5b452809b3172a2a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto/d-6IYplOFocCacKzxwXSOD8E0i7KZn-EPnyo3HZu7kw.woff
// module id = 783
// module chunks = 1